const axios = require('axios');

const api = axios.create({
  baseURL: 'https://config.commercemaster.com.br',
  headers: {
    Authorization: '476d14b6a3b89b5357e03573983a5975'
  }
});

module.exports = api;